import React from 'react'
import './styles/Modal.scss'
// TODO: add video player
import UserEmailConfirm from '../user/UserEmailConfirm';
import ParentSession from '../parent/ParentSession';
import TherapistSession from '../therapist/TherapistSession';
import PatientSession from '../practice_admin/patient/PatientSession';
import NewSession from '../therapist/NewSession'


const Modal = (props) => {
  let {name, data, isOpen, title, close, state} = props, ModalComponent;

  switch(name){
    case 'ParentSession':
      ModalComponent = ParentSession;
      break;
    case 'TherapistSession':
      ModalComponent = TherapistSession;
      break;
    case 'NewSession':
      ModalComponent = NewSession;
      break;
    case 'AdminPatientSession':
      ModalComponent = PatientSession;
      break;
    case 'UserEmailConfirm':
      ModalComponent = UserEmailConfirm;
      break;
    default:
      ModalComponent = () => <div className="modal-content">Hello</div>;
      break;
  }

  return <div className={ "modal-wrapper backdrop " + (isOpen? 'open ' : '')}
    onClick={close}>
    {isOpen && <div className="close" >X</div>}
    <div className={"modal "+ state} onClick={(e)=>{e.stopPropagation()}}>
      { title && <div className="modal-title">{title}</div>}
      <ModalComponent {...props} {...data} close={close} />
    </div>
  </div>;
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/ui/Modal.jsx